import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';
import AppLayout from '../components/AppLayout';
import { KeyboardShortcutsProvider } from '../components/KeyboardShortcutsModal/KeyboardShortcutsContext';
import { useCurrentUser } from '../services/userHooks';
import { useAuthRedirect } from '../hooks/useAuthRedirect';
import { useLogoutSync } from '../hooks/useLogoutSync';
import usePrefetchHomeBookmarks from '../hooks/usePrefetchHomeBookmarks';
import { isEhashEmailSettingsLocation } from '../utils/ehashSettings';

export const Route = createFileRoute('/_app')({
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { currentUser, isLoading, isError } = useCurrentUser();
  const location = useRouterState({ select: (state) => state.location });
  // /settings/email reached from an email link carries an ehash that stands
  // in for a session; every other route under _app still requires login.
  const allowAnonymous = isEhashEmailSettingsLocation(location.pathname, location.search);
  usePrefetchHomeBookmarks();
  useAuthRedirect(isLoading, isError, currentUser, allowAnonymous);
  useLogoutSync();

  return (
    <KeyboardShortcutsProvider>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </KeyboardShortcutsProvider>
  );
}
